<template lang="pug">
  v-container
      v-layout(row)
          v-btn( @click="$router.go(-1)" flat)
            v-icon arrow_back
            span back
      v-flex(xs12 v-if="event")
        v-card(color="white" flat light)
          v-layout( row wrap v-if="ep")
            v-flex.pa-3(xs12 sm4)
                v-img(
                  :src="imageSrc"
                  contain) 
            v-flex.pa-4(xs12 sm8)
              //v-card-title(primary-title)
              div
                div(class="title") {{ep.packageName}}
                div.body-2 ${{ep.cost}}
                div.py-3 {{ep.description}}
                div.subheading Includes:
                div.body-2 
                  ul
                    li(v-for="item in ep.contents") {{item}}
                  v-flex(xs12)
                v-layout(row wrap)
                  v-flex(xs12)
                    v-layout(row align-end)
                      v-flex(xs8)
                        v-text-field(xs8 v-model="amount" label="Amount" type="number" min="1") 
                      v-flex(xs4 bottom)
                        v-btn( icon @click="showSlider = !showSlider")
                          v-icon(v-if="!showSlider") expand_more
                          v-icon(v-else) expand_less
                  v-flex(v-if="showSlider")
                    v-slider(v-model = "amount" min="1" thumb-label)
                  v-flex(xs12 v-if="ep")
                    add-to-cart-btn(:item="ep", itemType="package") 
               
</template>
<script>

//Display the package details
import AddToCartBtn from '../components/AddToCartBtn'
export default {
  data:()=>({
    amount: 1,
    showSlider:false
  }),
  components:{AddToCartBtn},
  computed:{
    imageSrc(){return this.$store.state.baseImageURL + this.ep.imageURL+"?alt=media"},
    event(){
      return this.$store.state.events.find(el=>{
        let keys = Object.keys(el.packages)
        return keys.includes(this.$route.params.id)
      })
    },
    id(){
      return this.$route.params.id
    },
    ep(){
      let p = this.event.packages[this.$route.params.id]
      p.amount = this.amount
      p = JSON.parse(JSON.stringify(p))
      return p
    }
  },
  methods:{
    ammendPackage(){
      let p = this.ep
      p.amount = this.amount
      
      return p
    }
  }
}
</script>

